import React, { useState, useMemo } from 'react';
import ZoomModal from '../../../../DeviationViews/Full/Image/ZoomModal';
import Img from './ImageBase';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
var ImgZoomable = function (props) {
    var _a = useState(false), showFullview = _a[0], setShowFullview = _a[1];
    var file = props.file, deviation = props.deviation, imgStyles = props.imgStyles;
    var fullview = useMemo(function () { return DeviationMediaService.getLargestFullview(deviation); }, [deviation]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: function () {
                setShowFullview(true);
            }, style: { cursor: 'zoom-in' } },
            React.createElement(Img, { file: file, deviation: deviation, imgStyles: imgStyles })),
        showFullview && (React.createElement(ZoomModal, { src: cleanLinkSrc(fullview.src), srcSet: fullview.srcSet, width: fullview.width, height: fullview.height, isPixel: false, onClose: function () {
                setShowFullview(false);
            } }))));
};
ImgZoomable.displayName = 'ImgZoomable';
export default ImgZoomable;
//# sourceMappingURL=ImageZoomable.js.map